import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";
const getContractDetails = (state) => {

  return axios.get(API + "contracts/contract-details/"+state+"/",{headers: authHeader(),});
};
const DetailsContractService = {
    getContractDetails,
  };
  export default DetailsContractService;